import { h } from "preact";
import { RoutableProps } from "preact-router";
import { OrderCreator } from "../../../components/OrderCreator";
import { lunaEMG } from "../../../data/serialNumberSearchExecs";
import "./styles.scss";

export function LunaEMGOrder(props: RoutableProps & { id?: string }) {
    return <div class="stella-bio-order-page">
        <OrderCreator
            id={props.id}
            orderTypes={lunaEMG.orderTypes}
            serialRegexes={lunaEMG.orderedExecs}
        />
    </div>;
}
